module.exports = __webpack_public_path__ + "static/img/App item-5.6f26eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper2/App item-5.png
// module id = Gs1k
// module chunks = 12